<template>
  <stripe-checkout
    ref="checkoutRef"
    :pk="publishableKey"
    :session-id="sessionId"
  >
    <template slot="checkout-button">
      <slot name="paymentbtn">
        <button @click="checkout">Purchase!</button>
      </slot>
    </template>
  </stripe-checkout>
</template>

<script>
import { StripeCheckout } from "vue-stripe-checkout";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {
    StripeCheckout
  },
  data: () => ({
    loading: false,
    sessionId: "",
    publishableKey: process.env.VUE_APP_STRIPE_KEY
  }),
  computed: {
    ...mapGetters("user", ["userLoggedIn"])
  },
  methods: {
    async checkout() {
      if (!this.userLoggedIn) {
        return this.$router.push("/register");
      } else {
        console.log("Beginning to check out...");
        this.$http.get("/stripe/session").then(async (resp) => {
          console.log("Response!");
          console.log(resp.data.session);
          this.sessionId = resp.data.session.id;
          await this.$nextTick();
          this.$refs.checkoutRef.redirectToCheckout();
        });
      }
    }
  }
};
</script>
